/**
 * @generated SignedSource<<2f23fd0d25df1d55e0d1d8462700b0b0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type bulkVariationEditor_AttributesQuery$variables = {
  salesChannelID: string;
  sku: string;
};
export type bulkVariationEditor_AttributesQuery$data = {
  readonly merchantProductOptions: ReadonlyArray<{
    readonly label: string;
    readonly optionID: string;
  }>;
};
export type bulkVariationEditor_AttributesQuery = {
  response: bulkVariationEditor_AttributesQuery$data;
  variables: bulkVariationEditor_AttributesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesChannelID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sku"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      },
      {
        "kind": "Variable",
        "name": "sku",
        "variableName": "sku"
      }
    ],
    "concreteType": "MerchantProductGraphQLOption",
    "kind": "LinkedField",
    "name": "merchantProductOptions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optionID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkVariationEditor_AttributesQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "bulkVariationEditor_AttributesQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "3d774e2ed17cd43da7f54f48c7550d94",
    "id": null,
    "metadata": {},
    "name": "bulkVariationEditor_AttributesQuery",
    "operationKind": "query",
    "text": "query bulkVariationEditor_AttributesQuery(\n  $sku: String!\n  $salesChannelID: ID!\n) {\n  merchantProductOptions(sku: $sku, salesChannelID: $salesChannelID) {\n    optionID\n    label\n  }\n}\n"
  }
};
})();

(node as any).hash = "50301ca72fd858c46903378ab2971fa5";

export default node;
